import { FormEvent } from "react";
import styled from "styled-components";
import { useGlobal } from "../../../context/global";
import { useAlly } from "../../../context/ally";
import AllyService from "../../../services/ally.service";
import m from "../../../styles/molanturTheme";
import { Button, Dialog } from "../ui";

export default function ConfirmDeleteReservation() {
    const { setIsLoading } = useGlobal()
    const { setSummary, confirmDeleteReservationId, setConfirmDeleteReservationId } = useAlly()
    async function onSubmit(e: FormEvent<HTMLFormElement>) {
        e.preventDefault()
        setIsLoading(true)
        try {
            await AllyService.deleteReservation(confirmDeleteReservationId)
            setSummary(prev => prev.filter(item => item.reservation.id !== confirmDeleteReservationId))
            setConfirmDeleteReservationId('')
        } catch (error) {
            console.log(error)
        } finally {
            setIsLoading(false)
        }
    }
    return (
        <Dialog
            title="Borrar reserva"
            onClose={() => setConfirmDeleteReservationId('')}
            onSubmit={onSubmit}
            footer={
                <>
                    <Button type="submit" kind="danger" full icon="trash">Borrar reserva</Button>
                    <Button kind="ghost" full onClick={() => setConfirmDeleteReservationId('')}>Cancelar</Button>
                </>
            }
        >
            <Text>¿Seguro que quieres borrar esta reserva? Esta acción no se puede deshacer.</Text>
        </Dialog>
    )
}

const Text = styled.p`
    margin: 0;
    font-size: 14.5px;
    line-height: 1.5;
    color: ${m.color.inkSoft};
`
